export const PATHS = {
    MARKET: 'market',
    SNIPE: 'snipe',
    SWIFT: 'swift',
    STORK: 'stork'
}
